namespace RedBullMOBILE360.Sms {
    export class WhitelistMemberColumns {
        static columnsKey = 'Sms.WhitelistMember';
    }
}